import React from 'react';
import Loader from '../../components/Loader';
import MarketCard from '../../components/MarketCard';
import useGetData from '../../hooks/marketplace/useGetData';

const Foundations = ({ company }) => {
  const { data, loading, error } = useGetData('foundations', {
    body: { company },
  });
  const foundations = data ? data.foundations.flat() : [];
  if (error) return <div>Error al cargar los datos.</div>;
  if (loading) return <Loader />;
  if (foundations.length === 0) return <div>No hay fundaciones.</div>;

  return (
    <>
      {foundations.map((data, index) => (
        <MarketCard
          key={index}
          data={{
            ...data,
            type: 'foundation',
          }}
        />
      ))}
    </>
  );
};

export default Foundations;
